import { Vue } from 'vue-property-decorator';
import { DirectiveFunction, DirectiveBinding } from 'vue/types/options';

// カスタムディレクティブ videoタグの再生制御
const directive: DirectiveFunction = function(this: Vue, el: HTMLElement, binding: DirectiveBinding): void {
  if (!(el instanceof HTMLVideoElement)) return;
  const video = el as HTMLVideoElement;
  const isPlay: boolean = binding.value;
  if (isPlay) {
    video.play().catch((error: Error): void => {
      if (error instanceof DOMException && error.code === DOMException.ABORT_ERR) {
        // error.message: The play() request was interrupted by a call to pause(). https://goo.gl/LdLk22
        // androidでplay開始中にpauseすると発生するエラーは上記エラーメッセージのURLを参考に無視する
      } else throw error;
    });
  } else {
    video.pause();
  }
};

export default directive;
